import { render, staticRenderFns } from "./Lock.vue?vue&type=template&id=2217c14a&scoped=true&"
var script = {}
import style0 from "./Lock.vue?vue&type=style&index=0&id=2217c14a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2217c14a",
  null
  
)

export default component.exports